import { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import ModalWaiting from "../Components/ModalWaiting";

function SlideDigitalSaveLocal() {
  const [appData, setAppData] = useState(null);
  const [modalshow, setModalshow] = useState(true);
  const [waitingShow, setWaitingShow] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    document.title = "保存確認";

    try {
      const queries = new URLSearchParams(window.location.search);
      const dParam = queries.get('d') || "";
      const params = queries.get('params') || "slidedigitalsave_local";

      if (dParam) {
        // 文字化け対策済みの強力なデコード処理
        let decodedString = "";
        try {
          let b64 = dParam.replace(/-/g, '+').replace(/_/g, '/');
          while (b64.length % 4) b64 += '=';
          const binStr = window.atob(b64);
          const bytes = new Uint8Array(binStr.length);
          for (let i = 0; i < binStr.length; i++) {
            bytes[i] = binStr.charCodeAt(i);
          }
          decodedString = new TextDecoder('utf-8').decode(bytes);
        } catch (err) {
          decodedString = decodeURIComponent(escape(window.atob(dParam.replace(/-/g, '+').replace(/_/g, '/'))));
        }

        const jsonData = JSON.parse(decodedString);
        jsonData.params = params; // paramsもデータに統合
        
        setAppData(jsonData);
      }
    } catch (e) {
      console.error("Decode Error:", e);
    } finally {
      setModalshow(false);
    }
  }, []);

  const handleConfirm = async () => {
    setWaitingShow(true);

    // 1. ローカルストレージへの保存 (データの階層ズレを吸収)
    if (appData) {
      const dataToSave = appData.data || appData;
      localStorage.setItem('user_order_config', JSON.stringify(dataToSave));
    }

    // 2. GASへPOST送信してLINE案内メッセージを流す（データの階層ズレを吸収）
    const paymentAmount = appData?.payment || appData?.data?.payment || 1000;
    const gasBaseUrl = "https://script.google.com/macros/s/AKfycbxV78M9f2XuypgAEfJ3An-chZD1b_FmDONcUuuP9gCCMdY8hwCrGBatowwBVEXxIevS6A/exec";
    
    // ★ 修正: GASのdoPostへ送るデータに albumUrl と albumMethod を確実に追加
    const payload = {
      action: "sendAfterMessage",
      userID: appData?.userID || "",
      userName: appData?.userName || "",
      payMethod: appData?.payMethod || appData?.data?.payMethod || "",
      payment: paymentAmount,
      params: appData?.params || "",
      albumUrl: appData?.albumUrl || appData?.data?.albumUrl || "",       // ★前回追加分を復旧
      albumMethod: appData?.albumMethod || appData?.data?.albumMethod || "" // ★今回追加: 提出方法
    };

    try {
      await fetch(gasBaseUrl, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      setWaitingShow(false);
      setIsFinished(true);
    } catch (err) {
      setWaitingShow(false);
      alert("通信エラーが発生しました: " + err);
    }
  };

  // 画面の描画（データの階層ズレを吸収して正しく取得）
  let displayPayMethod = "";
  if (appData) {
    const rawPayMethod = appData.payMethod || (appData.data && appData.data.payMethod) || "";
    displayPayMethod = rawPayMethod === 'Bank' ? '銀行振込' : rawPayMethod;
  }

  return (
    <>
      <style jsx>{`
        .grid-area { display: grid; height: 100vh; grid-template-rows: 90% 10%; grid-template-columns: 100%; }
        .top-area { grid-row: 1; grid-column: 1; overflow-y: auto; display: flex; justify-content: center; align-items: center; background-color: #f4f6f9; padding: 20px;}
        .bottom-area { grid-row: 2; grid-column: 1; background: #fff; border-top: 1px solid #e9ecef; display: flex; justify-content: center; align-items: center; padding: 0 15px; }
        .maincard { max-width: 500px; width: 100%; border-radius: 12px; }
        .card-title-custom { font-size: 1.25rem; font-weight: bold; color: #1a73e8; text-align: center; padding: 10px 0; }
        .w-80 { width: 80%; }
        .info-box { background-color: #f8f9fa; border-radius: 8px; padding: 15px; margin-bottom: 20px; border: 1px solid #e9ecef; }
        .info-label { font-size: 0.85rem; color: #6c757d; margin-bottom: 2px; }
        .info-value { font-size: 1rem; font-weight: bold; color: #212529; margin-bottom: 10px; }
      `}</style>

      <div className="grid-area">
        <div className="top-area">
          {appData && (
            <Card className="maincard shadow-sm border-0">
              <Card.Body>
                <Card.Title className="card-title-custom mb-3">お申し込み内容の確認</Card.Title>
                {!isFinished ? (
                  <>
                    <div className="text-center mb-3 small">
                      以下の内容で受け付けました。
                    </div>
                    <div className="info-box shadow-sm">
                      <div className="info-label">お名前</div>
                      <div className="info-value">{appData.userName ? appData.userName : "お客様"} 様</div>
                      
                      <div className="info-label">お支払い方法</div>
                      <div className="info-value">{displayPayMethod}</div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <Button variant="primary" className="w-80 py-3 fw-bold shadow" onClick={handleConfirm}>
                        確認して終了する
                      </Button>
                    </div>
                  </>
                ) : (
                  <Alert variant="success" className="text-center py-4 border-0 shadow-sm mt-2">
                    <h5 className="fw-bold mb-3">ありがとうございます</h5>
                    <p className="mb-0 small">
                      お申し込み内容を保存しました。<br/>
                      LINEにてお支払い案内をお送りしましたので、ご確認ください。
                    </p>
                  </Alert>
                )}
              </Card.Body>
            </Card>
          )}
        </div>
        <div className="bottom-area">
          <div className="text-center text-muted small w-100">
            ×ボタンから画面を閉じてください
          </div>
        </div>
      </div>
      <ModalWaiting show={modalshow || waitingShow} />
    </>
  );
}

export default SlideDigitalSaveLocal;
